/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/no-array-index-key */
import dayjs from 'dayjs';
import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { MainButton } from '../../../components/buttons';
import WeeklyLogModalParent from './WeeklyLogModalParent';
import {
  CustomTextAreaField,
  TextInputField,
} from '../../../components/inputs';
import { FlexBox } from '../../../components/tableItems';
import useWeeklyLogStore from '../../../stores/weeklyLog/WeeklyLogStore';
import { onlyNumbers } from '../../../helpers/validateInputs';
import { outOfficeValuesArr, weekendDaysArr } from '../WeeklyLogModel';

interface WeeklyLogFormProps {
  loadingSave: boolean;
  saveForm: () => Promise<void>;
}

const WeeklyLogForm: React.FC<WeeklyLogFormProps> = ({
  loadingSave,
  saveForm,
}) => {
  const { formWeeklyLog, updateFormWeeklyLog, weeklyLogFetchResponse } =
    useWeeklyLogStore();
  const [modalForm, setModalForm] = useState(false);
  const openModalForm = () => setModalForm(true);
  const closeModalForm = () => setModalForm(false);
  const [disabled, setDisabled] = useState(false);

  const handleSave = async () => {
    await saveForm();
    closeModalForm();
  };

  const checkValidation = () => {
    const findNotNull = formWeeklyLog.find(
      item => item.follow_ups !== null || item.responses_sent !== null,
    );

    if (!findNotNull) setDisabled(true);
    else setDisabled(false);
  };

  useEffect(() => {
    checkValidation();
  }, [formWeeklyLog]);

  return (
    <>
      <MainButton
        loading={false}
        variant="contained"
        sx={{
          background: '#84D0F0',
          fontSize: 12,
          color: 'black',
          '&:hover': {
            backgroundColor: '#84D0F0',
          },
        }}
        disabled={false}
        onClick={openModalForm}
      >
        Edit
      </MainButton>
      <WeeklyLogModalParent
        open={modalForm}
        closeModal={closeModalForm}
        title="Edit Weekly Log"
        width={700}
        maxHeight={1000}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          sx={{ mb: 3, borderBottom: '0.5px solid gray' }}
        >
          <Grid item xs={3} fontWeight={600} fontSize={14}>
            Day
          </Grid>
          <Grid item fontWeight={600} fontSize={14} xs={2}>
            Follow Ups
          </Grid>
          <Grid item fontWeight={600} fontSize={14} xs={2}>
            Responses Sent
          </Grid>
          <Grid item fontWeight={600} fontSize={14} xs={2}>
            Notes
          </Grid>
        </Grid>
        {weeklyLogFetchResponse.map((item, index) => {
          const { follow_ups, responses_sent, notes, out_of_office } =
            formWeeklyLog[index];
          const valueFollowUp = `${follow_ups ?? ''}`;
          const valueResponsesSent = `${responses_sent ?? ''}`;

          return (
            <Grid
              key={item.id}
              container
              spacing={{ xs: 2, md: 3 }}
              sx={{ mb: 3, fontSize: 14 }}
            >
              <Grid item xs={3} textTransform="capitalize">
                {dayjs(item.date).format('ddd')}{' '}
                {dayjs(item.date).format('MM-DD-YYYY')}
              </Grid>
              <Grid item xs={2}>
                <TextInputField
                  value={valueFollowUp}
                  name="Follow Ups"
                  disabled={
                    item.status === 'completed' ||
                    (weekendDaysArr.includes(item.day_name) &&
                      !outOfficeValuesArr.includes(out_of_office ?? ''))
                  }
                  error={false}
                  size="small"
                  onChange={e => {
                    if (e.target.value === '') {
                      updateFormWeeklyLog(index, {
                        follow_ups: null,
                      });
                      return;
                    }
                    const newValue = onlyNumbers(e.target.value);
                    updateFormWeeklyLog(index, {
                      follow_ups: parseInt(newValue, 10),
                    });
                  }}
                  fullWidth
                  type="text"
                  placeholder="Follow Ups"
                  id="follow-ups"
                />
              </Grid>
              <Grid item xs={2}>
                <TextInputField
                  value={valueResponsesSent}
                  name="Responses Sent"
                  disabled={
                    item.status === 'completed' ||
                    (weekendDaysArr.includes(item.day_name) &&
                      !outOfficeValuesArr.includes(out_of_office ?? ''))
                  }
                  error={false}
                  size="small"
                  onChange={e => {
                    if (e.target.value === '') {
                      updateFormWeeklyLog(index, {
                        responses_sent: null,
                      });
                      return;
                    }
                    const newValue = onlyNumbers(e.target.value);
                    updateFormWeeklyLog(index, {
                      responses_sent: parseInt(newValue, 10),
                    });
                  }}
                  fullWidth
                  type="text"
                  placeholder="Responses Sent"
                  id="responses-sent"
                />
              </Grid>
              <Grid item xs={5}>
                <CustomTextAreaField
                  placeholder="Note"
                  minRows={1}
                  multiline
                  maxRows={Infinity}
                  disabled={false}
                  required
                  helperText=""
                  error={false}
                  value={notes}
                  onChange={e => {
                    updateFormWeeklyLog(index, { notes: e.target.value });
                  }}
                />
              </Grid>
            </Grid>
          );
        })}
        <FlexBox justifyContent="end">
          <MainButton
            loading={loadingSave}
            variant="contained"
            sx={{
              background: '#BAF372',
              fontSize: 12,
              color: 'black',
              '&:hover': {
                backgroundColor: '#BAF372',
              },
            }}
            disabled={loadingSave || disabled}
            onClick={handleSave}
          >
            Save
          </MainButton>
        </FlexBox>
      </WeeklyLogModalParent>
    </>
  );
};

export default WeeklyLogForm;
